import { fg } from '@atlaskit/platform-feature-flags/fg';

export function getRemixFeatureArea({
	remixType,
	existingFeatureArea,
}: {
	remixType?: string;
	existingFeatureArea?: string;
}): string | undefined {
	if (!fg('maui_remix_feature_area_by_type')) {
		return existingFeatureArea;
	}

	return remixType ? `remix-${remixType}` : (existingFeatureArea ?? 'remix');
}
